var app = app || angular.module('harriApp');

app.controller(
    'customJobSearchController', ['$scope', '$state', 'DispatcherServices', 'hUser', 'localize',
    'hEvent', 'searchBackend', 'SavedSearch', '$location', '$modal',
    function ($scope, $state, DispatcherServices, hUser, localize, hEvent, searchBackend, SavedSearch, $location, $modal) {
        const DEFAULT_SELECTED_DISTANCE_INDEX = 0;
        const JOBS_SEARCH_LOCATION_RADIUS = 20;
        $scope.mapEvents = {};
        const ZOOM_LEVEL = 15;
        const SCROLL_THRESHOLD = 240;
        const PAGE_SOURCE = 'CUSTOM_JOB_SEARCH';
        var loadedJobs = 0;
        var jobsSearchTimeout = null;
        const DEFAULT_POSTAL_CODE_RADIUS = '20';
        let direction = localize.isRTL() ? 'rtl' : 'ltr';
        var $jobsLocations = $(".jobs-locations-mobile");
        $scope.selectedLocations = [];
        $scope.sliderOptions = {
            start: JOBS_SEARCH_LOCATION_RADIUS,
            step: 2,
            direction: direction,
            range: {
                'min': 0,
                'max': 50
            },
            stepped: true,
            pips: {
                mode: 'values',
                values: [0, 50],
                density: 15
            }
        };

        $scope.doDelayedSearch = (delay = 700) => {
            const searchTimeout = 'searchTimeout';

            $timeout.cancel($scope.timeouts[searchTimeout]);

            $scope.timeouts[searchTimeout] = $timeout(async () => {
                if ($scope && angular.isFunction($scope.doSearch)) {
                    await $scope.doSearch();
                }
            }, delay);
        };

        const isMobileOrSmallScreen = () => {
            return deviceChecker.isMobile() || deviceChecker.isTinyScreen();
        };

        $scope.hideLocationsMap = () => {
            $scope.showLocationMap = false;
        };

        const setSearchLocation = (data, locationSource) => {
            const newLocation = data;
            if (newLocation.latitude && newLocation.longitude) {
                const locationObj = $scope.searchFiltersRequest.userLocation;

                if (!locationObj || locationObj.source === 'network') {
                    newLocation.source = locationSource;
                    $scope.searchFiltersRequest.userLocation = newLocation;
                }
            }
        };

        const getUserLocation = async () => {
            let data;
            let source = "network";
            try {
                const deferred = $q.defer();
                if (isMobileOrSmallScreen()) {
                    data = await hUser.getUserDeviceLocation();
                    source = "device";
                    setSearchLocation(data, source);
                } else {
                    data = await hUser.getUserLocation();
                }
                setSearchLocation(data, source);
                deferred.resolve();
                return deferred.promise;
            } catch (error) {
                $scope.searchFiltersRequest.useLocation = false;
                return Promise.reject(error);
            }
        };


        const openBannerSettingsPanel = () => {
            const template = DispatcherServices.getNunjucks()
                .render("modules/search/controllers/custom-job-search/partials/banner-settings.tmpl.html", {
                    languages: $scope.languages,
                });

            $('.settings-panel').html(template);
            $scope.showSettingsPanel = true;
            $('.settings-panel').show();
        }

        const closeBannerSettingsPanel = () => {
            $scope.showSettingsPanel = false;
            $('.settings-panel').hide();
        }

        const changeLanguage = (languageCode) => {
            let toLang = languageCode || $scope.defaultLang;
            HStorageManager.put({
                key: 'lang',
                storageLevel: HStorageManager.StorageLevels.COOKIES,
                value: toLang,
                expiryDays: 30,
                codec: false
            });

            hEvent.track(
                "language_change",
                {
                    "to": toLang,
                    "from": $scope.currentLang,
                    "page": $state.current.name
                },
                () => {

                    $timeout(async () => {
                        hRedirect(hGetCurrentUrl(toLang));
                    });
                });
        };

        const initLanguagesSelector = () => {
            $scope.defaultLang = $scope.currentLang = localize.getLang();
            $('.language-selector .select-block').val($scope.defaultLang);
        };

        const renderBanner = (config) => {
            const template = DispatcherServices.getNunjucks()
                .render("modules/search/controllers/custom-job-search/partials/banner.tmpl.html", {
                    languages: $scope.languages,
                    showSettingsPanel: $scope.showSettingsPanel,
                    config: config
                });
            $('.custom-job-search-banner').html(template);
        }

        const renderApprenticeJobs = (apprenticeJobs, isAppending) => {
            const template = DispatcherServices.getNunjucks()
                .render("modules/search/controllers/custom-job-search/partials/custom-job-card-list.tmpl.html", {
                    jobSearchResult: apprenticeJobs,
                    numberOfCards: $scope.numberOfCards,
                    loading: $scope.loading,
                    isAppending: isAppending,
                    isFiltered: $scope.isFiltered
                });
            if (isAppending) {
                $(".job-list-container").append(template);
            } else {
                $("#custom-jobs-list").html(template);
            }
        }

        const calculateNumberOfJobs = () => {
            let numberOfAllJobs = 0;
            for (let i in $scope.listOfLocations) {
                numberOfAllJobs += parseInt($scope.listOfLocations[i].jobs_count);
            }
            $('.jobsCount').html(String(numberOfAllJobs));
        }

        const renderLocationSelector = () => {
            const template = DispatcherServices.getNunjucks()
                .render("modules/search/controllers/custom-job-search/partials/locations-selector.tmpl.html", {
                    listOfLocations: $scope.listOfLocations,
                    selectedLocations: $scope.selectedLocations
                });
            $('.locations-selector-wrapper').html(template);
        }

        const encodeUrlQuery = (filterObject) => {
            return Object.entries(filterObject).map(([key, value]) => {
                if (Array.isArray(value)) {
                    value = value.join(",");
                }
                return `/${key}/${encodeURIComponent(value)}`;
            }).join('');
        };

        const changeUrl = () => {
            let searchObj = {};

            if ($scope.searchFiltersRequest.keywords) {
                searchObj['query'] = $scope.searchFiltersRequest.keywords;
            }

            if ($scope.searchFiltersRequest.selectedPositions && $scope.searchFiltersRequest.selectedPositions.length > 0) {
                searchObj['position'] = $scope.searchFiltersRequest['positions'];
            }

            if ($scope.searchFiltersRequest.selectedCategories && $scope.searchFiltersRequest.selectedCategories.length > 0) {
                searchObj['category'] = $scope.searchFiltersRequest['categories'];
            }

            if ($scope.searchFiltersRequest.locations &&
                $scope.searchFiltersRequest.locations.location_key &&
                $scope.searchFiltersRequest.locations.lat &&
                $scope.searchFiltersRequest.locations.lng) {

                searchObj['location'] = [];
                searchObj.location.push($scope.searchFiltersRequest.locations.lat + '' || '');
                searchObj.location.push($scope.searchFiltersRequest.locations.lng + '' || '');
                searchObj.location.push($scope.searchFiltersRequest.locations.location_key + '' || '');
            }

            let filtersString = '';
            for (let i in searchObj) {
                filtersString += (filtersString ? '&' : '') + i + '=' + searchObj[i];
            }

            $timeout.cancel(jobsSearchTimeout);
            jobsSearchTimeout = $timeout(function () {
                $state.go("pobhotels", {
                    filters: encodeURIComponent(filtersString)
                });
                $scope.$apply();
            }, 1);
        };

        $scope.toggleFilters = () => {
            $('.mobile-filters-panel').show();
        }

        $scope.closeMobileFilters = () => {
            $('.mobile-filters-panel').hide();
        }

        $scope.toggleLocations = () => {
            $('.jobs-locations-mobile').show();
            $('.top-bar').removeClass('d-none');
            $('.top-bar').addClass('visible');

        }

        $scope.closeMobileLocations = () => {
            $('.jobs-locations-mobile').hide();
            $('.top-bar').addClass('d-none');
            $('.top-bar').removeClass('visible');
        }

        $scope.toggleApplyFilters = () => {
            $scope.closeMobileFilters();
            $scope.doDelayedSearch();
        }

        $scope.doSearch = async function (isAppending) {
            const params = buildSearchParams(isAppending);
            changeUrl();
            renderApprenticeJobs({}, isAppending);
            try {
                await performSearch(params, isAppending);
            } catch (error) {
                console.error(error);
            }
        };

        const buildSearchParams = (isAppending) => {
            const params = {
                limitations: 30,
                source: "web",
                search_phrase: $scope.searchFiltersRequest.keywords,
                positions: [],
                categories: []
            };
            $scope.isFiltered = false;

            // Handle positions and categories
            if (params.positions.length === 0 && $scope.searchFiltersRequest.selectedCategories) {
                params.categories = _.pluck($scope.searchFiltersRequest.selectedCategories, 'name');
                $scope.isFiltered = true;
            }

            if ($scope.searchFiltersRequest.selectedPositions && $scope.searchFiltersRequest.selectedPositions.length > 0) {
                params.positions = _.pluck($scope.searchFiltersRequest.selectedPositions, 'name');
                params.categories = [];
                $scope.isFiltered = true;
            }

            if ($scope.searchFiltersRequest.selectedTypes && $scope.searchFiltersRequest.selectedTypes.length > 0) {
                params['availability'] = [];
                $scope.searchFiltersRequest.selectedTypes.forEach(function(jobType) {

                    if (jobType.id === 'FULL_TIME') {
                        params['availability'].push('full_time');
                    }

                    if (jobType.id === 'PART_TIME') {
                        params['availability'].push('part_time');
                    }
                });
                $scope.isFiltered = true;
            }

            params['postal_code'] = $scope.searchFiltersRequest.postal_code || '';
            params['postal_code_radius'] = $scope.searchFiltersRequest.postal_code_radius.value || DEFAULT_POSTAL_CODE_RADIUS;
            if ($scope.searchFiltersRequest.postal_code ||
                ($scope.searchFiltersRequest.postal_code_radius && $scope.searchFiltersRequest.postal_code_radius.value)) {
                $scope.isFiltered = true;
            }

            if ($scope.searchFiltersRequest.useLocation) {
                let latitude = $scope.searchFiltersRequest.userLocation && $scope.searchFiltersRequest.userLocation.latitude;
                let longitude = $scope.searchFiltersRequest.userLocation && $scope.searchFiltersRequest.userLocation.longitude;
                if (!isNaN(latitude) && !isNaN(longitude)) {
                    params['radius'] = $scope.sliderOptions.start;
                    params.locations = [`${latitude || ''}`, `${longitude || ''}`];
                    params['sort'] = ['distance'];
                } else {
                    console.error("Trying to search useLocation:", $scope.searchFiltersRequest.useLocation, "User Location:", $scope.searchFiltersRequest.userLocation);
                }
                $scope.isFiltered = true;
            }

            if (isAppending) {
                params['offset'] = loadedJobs;
            }

            if ($scope.selectedLocations.length) {
                params['brand_level_ids'] = _.pluck($scope.selectedLocations, 'id');
            }

            return params;
        };

        function renderLoader(isAppending) {
            const template = DispatcherServices.getNunjucks()
                .render("modules/search/controllers/custom-job-search/partials/custom-card-loader.tmpl.html", {
                    numberOfCards: $scope.numberOfCards,
                });
            if (isAppending) {
                $(".job-list-container").append(template);
            } else {
                $("#custom-jobs-list").html(template);
            }

            $('.card-loader').show();
        }

        const syncScope = () => {
            setTimeout(() => {
                $scope.$digest();
            }, 1);
        };

        const performSearch = async (params, isAppending) => {
            renderLoader(isAppending);
            $scope.isLoadMorePageDisabled = true;
            let searchResult;
            searchResult = await searchBackend.searchFor($scope.selectedGroup, params, $scope.isLoggedin);
            const promises = searchResult.promises.map(async (promiseHolder, index) => {
                try {
                    const resp = await promiseHolder.promise;
                    resp.data = resp.data.data;

                    $scope.isLoadMorePageDisabled = !(resp.data && resp.data.results && resp.data.results.length > 0);
                    if (isAppending) {
                        loadedJobs += resp.data.results.length;
                        $scope.searchResultsConfig[searchResult.promises[index].type].results = $scope.searchResultsConfig[searchResult.promises[index].type].results.concat(resp.data.results);
                    } else {
                        if (resp.data && resp.data.results && resp.data.results.length > 0) {
                            loadedJobs = resp.data.results.length;
                            $scope.searchResultsConfig[searchResult.promises[index].type].results = resp.data.results;
                        } else {
                            loadedJobs = 0;
                            $scope.searchResultsConfig[searchResult.promises[index].type].results = [];
                        }
                    }

                    $scope.searchResultsConfig[searchResult.promises[index].type].count = resp.data.hits;
                    let numberOfJobs = $scope.searchResultsConfig[searchResult.promises[index].type].count;
                    let content =  numberOfJobs ? $filter("translate")('Jobs') + ' (' + numberOfJobs  + ')' : '';
                    $('.apprentice-jobs-container #numberOfJobs').html(content);

                    renderApprenticeJobs(resp.data, isAppending);

                    if (numberOfJobs > 0) {
                        $('.empty-board').addClass('d-none');
                    } else {
                        $('.empty-board').removeClass('d-none');
                    }

                    $('.card-loader').remove();
                    $('.job-list-container').show();
                    syncScope();

                } catch (error) {
                    $scope.isLoadMorePageDisabled = false;
                }
                finally {
                    $('.card-loader').remove();
                    $('.job-list-container').show();
                    syncScope();
                }
            });

            await Promise.all(promises);
        };

        const initializeProperties = () => {
            $scope.languages = [
                {id: 'en', name: 'EN', fullName: $filter('translate')('English')},
                {id: 'fr', name: 'FR', fullName: $filter('translate')('French')},
                {id: 'es', name: 'ES', fullName: $filter('translate')('Èspaneol')}
            ];

            $scope.selectedGroup = 'pride_apprentice_jobs';
            $scope.selectedCategories = [];
            $scope.selectedAvailability = [];
            $scope.timeouts = {};
            $scope.isLoadMorePageDisabled = false;
            $scope.loading = false;
            $scope.isLoggedin = hUser.isLoggedIn();
            $scope.positions = {'selectedCategory': null};
            $scope.mainActiveTab = 'employeeJobs';
            $scope.isSelectedFilter = {};
            $scope.searchResultsConfig = {
                default: {
                    count: 0,
                    results: []
                },
                pride_apprentice_jobs: {
                    count: 0,
                    results: [],
                    code: 'PRIDE_OF_BRITAIN',
                    banner: {
                        logoPath: '../images/PoB/pob-logo.svg',
                        mainTitle: $filter('translate')('PoB Hotels'),
                        backgroundImage: '../images/PoB/banner-background.png'
                    }
                }
            };
        };

        const initializeSearchFilters = (clear) => {
            $scope.searchFiltersRequest = {
                keywords: '',
                locations: [],
                useLocation: false,
                selectedTypes: [],
                positions: [],
                categories: [],
                availability: [],
                brand_level_ids: []
            };

            $scope.jobTypesList = [
                {
                    id: 'FULL_TIME',
                    name: $filter("translate")('Full Time')
                },
                {
                    id: 'PART_TIME',
                    name: $filter("translate")('Part Time')
                },
            ];

            getUserLocation();

            if (clear) {
                toggleSelectAll(clear);
            }
        };

        $scope.clearFilters = async () => {
            initializeSearchFilters(true);
            initializeLocationDistanceOptions();
            await $scope.doSearch();
        }

        const initializeLocationDistanceOptions = () => {
            $scope.locationDistanceOptions = [
                {label: $filter("translate")("100 mi"), value: 100},
                {label: $filter("translate")("50 mi"), value: 50},
                {label: $filter("translate")("30 mi"), value: 30},
                {label: $filter("translate")("20 mi"), value: 20},
                {label: $filter("translate")("10 mi"), value: 10},
                {label: $filter("translate")("5 mi"), value: 5},
                {label: $filter("translate")("3 mi"), value: 3},
                {label: $filter("translate")("1 mi"), value: 1}
            ];

            $scope.searchFiltersRequest.postal_code_radius = $scope.locationDistanceOptions[DEFAULT_SELECTED_DISTANCE_INDEX];
        };

        $scope.sliderEventHandlers = {
            update: (values, handle, unencoded) => {
                $scope.mapEvents.setZoomLevel(ZOOM_LEVEL - ((values[0] / 50) * 7.7));
                if ($scope.searchFiltersRequest.useLocation) {
                    $scope.doDelayedSearch();
                }
            }
        };

        const getPositionsFilters = async () => {
            try {
                $scope.categories = [];
                $scope.positions = [];
                $scope.allPositions = [];
                let allCategories = [];
                let positionsFilters = await searchBackend.getPositionsFilters();
                for (let i in positionsFilters) {
                    allCategories.push(positionsFilters[i].PositionType);
                }

                for (let j in allCategories) {
                    let positions = allCategories[j].Position;
                    $scope.allPositions = $scope.allPositions.concat(positions);
                }
                $scope.categories = allCategories;
                $scope.positions = $scope.allPositions;
                $scope.$digest();
            } catch (e) {

            }
        };

        $scope.onChangeCategories = async () => {
            let selectedCategories = $scope.searchFiltersRequest.selectedCategories;
            let selectedCategoryPositions = [];
            $scope.positions = [];
            let positions = [];
            if (selectedCategories && selectedCategories.length) {
                for (let i in selectedCategories) {
                    positions = selectedCategories[i]['Position'];
                    selectedCategoryPositions = selectedCategoryPositions.concat(positions);
                }
                $scope.positions = selectedCategoryPositions;
            } else {
                $scope.positions = $scope.allPositions;
            }
            let positionCodes = _.pluck($scope.positions, 'code');

            $scope.searchFiltersRequest.selectedPositions = _.filter($scope.searchFiltersRequest.selectedPositions, (position) => {
                return positionCodes.indexOf(position.code) > -1;
            });

            await $scope.doDelayedSearch();
            $scope.$digest();
        };

        $scope.onUseLocationChange = async () => {
            if ($scope.searchFiltersRequest.useLocation) {
                setTimeout(async () => {
                    $scope.searchFiltersRequest.useLocation = false;
                    $scope.showLocationMap = false;
                    await $scope.doSearch();
                }, 2000);
            } else {
                $scope.searchFiltersRequest.useLocation = true;
                $scope.showLocationMap = true;
                setTimeout(() => {
                    $scope.mapEvents.setZoomLevel(ZOOM_LEVEL - ((JOBS_SEARCH_LOCATION_RADIUS / 50) * 7.7)); // set the initial zoom level.
                }, 1000);

                try {
                    $scope.locations = await hUser.getUserLocation();
                    $scope.mapLocations = [];
                    $scope.mapLocations.push([
                        "<div class='location-popup'>" +
                        "<div class='details'>" +
                        "<div class='name'>" + $filter("translate")("My Location") + "</div>" +
                        "<div class='location'></div>" +
                        "</div>" +
                        "</div>",
                        $scope.locations['latitude'], $scope.locations['longitude']]);
                    $scope.$digest();
                } catch (e) {
                    console.error("something went wrong")
                }
            }
        };

        const showJobAlertsModal = () => {
            $modal({
                controller: 'getJobAlertsModal',
                templateUrl: '../modules/profiles/modals/get-job-alerts/get-job-alerts.modal.html',
                show: true,
                resolve: {
                    modalData: () => {
                        return {
                            source: PAGE_SOURCE,
                            listOfLocations: $scope.listOfLocations,
                            positions_codes: _.pluck($scope.searchFiltersRequest.selectedPositions, 'code'),
                            onSuccess: (res) => {
                                hAlert({
                                        title: $filter("translate")("A verification email has been sent to your email account"),
                                        text: "Click on the link to verify your subscription and start receiving " +
                                            res.brand.name + " job alerts",
                                        custom_class: 'gp-career-portal-alert'
                                    },
                                    null,
                                    null,
                                    null,
                                    '.custom-job-search-container'
                                );
                            },
                            onError: (err, email, brand) => {
                                hAlert({
                                        title: $filter("translate")("Email already exists"),
                                        text: email + " " + $filter("translate")("email already have jobs alerts for") +
                                            " " + brand.name,
                                        custom_class: 'gp-career-portal-alert',
                                        button: {
                                            'confirm_text': $filter("translate")("Update Job Alerts"),
                                            'on_confirm': function () {
                                            }
                                        }
                                    },
                                    null,
                                    null,
                                    null,
                                    '.custom-job-search-container'
                                );
                            }
                        };
                    }
                }
            });
        };

        const getListOfEnterprises = async () => {
            let type = $scope.searchResultsConfig[$scope.selectedGroup].code;
            let result = await CoreReaderAPI.getListOfEnterprises(type);
            return result.brands;
        }

        const getSelectedLocation = () => {
            return _.map(_.where($scope.listOfLocations, {selected: true}), (location) => {
                return location;
            });
        };

        const handleSelectAllClasses = () => {
            if ($scope.selectedLocations.length) {
                $('.select-all').addClass('selected');
                $('.select-option').addClass('selected');
            } else {
                $('.select-all').removeClass('selected');
                $('.select-option').removeClass('selected');
            }
        }

        const toggleSelectAll = (clear) => {
            let selected = true;
            if ($scope.selectedLocations.length === $scope.listOfLocations.length && !clear) {
                selected = false;
            }

            $scope.listOfLocations.forEach((item) => {
                item.selected = selected;
            });

            $scope.selectedLocations = getSelectedLocation();
            renderLocationSelector();
            handleSelectAllClasses()
        }

        const handleSingleSelectClasses = (location) => {
            let $element = $('.select-option[data-location-id="' + location.id + '"]');
            if ($element.length > 0 && location.selected) {
                $element.addClass('selected');
            } else {
                $element.removeClass('selected');
            }
        }

        const toggleLocationSelected = (location) => {
            location.selected = !location.selected;
            $scope.listOfLocations.forEach((item) => {
                if (item.id === location.id) {
                    item.selected = location.selected;
                }
            });
            $scope.selectedLocations = getSelectedLocation();
            renderLocationSelector();
            handleSingleSelectClasses(location);
            if ($scope.selectedLocations.length) {
                $('.select-all').addClass('selected');
            } else {
                $('.select-all').removeClass('selected');
            }
        }

        const getLocationById = (id) => {
            return $scope.listOfLocations.find((location)=> {
                return location.id == id;
            })
        };

        const init = async () => {
            initializeProperties();
            initializeSearchFilters();
            initializeLocationDistanceOptions();
            await getPositionsFilters();
            $scope.numberOfCards = [];
            $scope.cardsCount = 8;
            for (var i = 0; i < $scope.cardsCount; i++) {
                for (let i = 0; i < $scope.cardsCount; i++) {
                    $scope.numberOfCards.push({
                        id: i
                    })
                }
            }

            renderBanner($scope.searchResultsConfig[$scope.selectedGroup]);
            try {
                await getUserLocation();
            } catch (e) {
                $scope.doDelayedSearch();
            }
            $scope.doDelayedSearch();
            initLanguagesSelector();
            $scope.listOfLocations = await getListOfEnterprises();
            calculateNumberOfJobs();
            renderLocationSelector();
            toggleSelectAll();
        };

        var totalHeight = $("body").height() - $('.jobs-board-body').offset().top + SCROLL_THRESHOLD;
        const loadMoreJobs = function () {
            if (!$scope.isLoadMorePageDisabled && $scope.searchResultsConfig[$scope.selectedGroup].count > loadedJobs &&
                (totalHeight + $(document).scrollTop() > $('.jobs-board-body').height())) {
                $scope.doSearch(true);
            }
        };

        $(document).ready(function () {
            $(document).on('change', '.banner .language-row .select-block', function (event) {
                const selectedLang = $(event.target).val();
                changeLanguage(selectedLang);
            });

            $(document).on('click', '.banner .banner-settings', function (event) {
                openBannerSettingsPanel();
                $(`#${$scope.defaultLang}`).addClass('selected');
            });

            $(document).on('click', '.banner-settings-panel .close-button', function (event) {
                closeBannerSettingsPanel();
            });

            $(document).on('click', '.banner-settings-panel .lang-options .lang-option', function (event) {
                $('.lang-option').removeClass('selected');
                $(event.currentTarget).addClass('selected');
                const selectedLangId = $(event.currentTarget).attr('id');

                changeLanguage(selectedLangId);
            });

            $(window).on('resize', function (e) {
                totalHeight = $("body").height() - $('.jobs-board-body').offset().top + SCROLL_THRESHOLD;
                loadMoreJobs();
            });

            $('#custom-jobs-list').on('scroll', function (event)  {
                loadMoreJobs();
            });

            $(document).on('click', '.job-alerts-button', async (event) => {
                showJobAlertsModal();
            });

            $(document).on('click', '.locations-selector .select-all', async (event) => {
                toggleSelectAll();
                $scope.doDelayedSearch()
            });

            $(document).on('click', '.jobs-locations-mobile .close-btn', function (event) {
                $scope.closeMobileLocations();
            });


            $(document).on('click', '.locations-selector .select-option', function (event) {
                let locationId = event.currentTarget.getAttribute("data-location-id");
                let targetLocation = getLocationById(locationId);
                toggleLocationSelected(targetLocation);
                $scope.doDelayedSearch()
            });


            $(document).on('click', '.banner .mobile-view #search-icon', function (event) {
                $('.content-row').addClass('d-none');
                $('.language-row').addClass('d-none');
                $('.nav-row-mobile').hide();
                $('.banner').attr('style', 'background-image: unset');
                $('.banner').addClass('auto-height');
                setTimeout(() => {
                    $('.search-bar-container').show();
                    $('.search-bar-container').addClass('show');
                }, 500);
            });

            $(document).on('change', '.banner .mobile-view #search-query', function (event) {
                const searchQuery = $(event.target).val();
                $scope.searchFiltersRequest.keywords = searchQuery;
                $scope.doDelayedSearch();
            });


            $(document).on('click', '.banner .mobile-view #arrow-icon', function (event) {
                $('.banner').removeClass('auto-height');
                $('.content-row').removeClass('d-none');
                $('.language-row').removeClass('d-none');
                $('.nav-row-mobile').show();
                $('.banner').attr('style', 'background-image: url(' + $scope.searchResultsConfig[$scope.selectedGroup].banner.backgroundImage + ')');
                $('.search-bar-container').hide();
                $('.search-bar-container').removeClass('show');
            });
        });


        init();

    }
]);
